<template>
    <div
        class="container sticky_nav_container d-flex justify-content-center align-items-center "
    >
        <div
            v-for="(item, key) in items"
            :key="key"
            class="col px-lg-5 text-nowrap mt-md-1 nav_link scrollto "
        >
            <a :href="'#'+item.link" @click.stop.prevent="scrollTo(item.link)">
                <span :class="classname">{{ item.text }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: []
        },
        classname: {
            type: String,
            default: ""
        }
    },
    methods: {
        scrollTo(item) {
            this.$emit("scroll-to", item);
        }
    }
};
</script>

<style></style>
